/**
 * Ryan O'Dowd
 * 2023-08-02
 * © Copyright 2023 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  Platform,
} from 'react-native';

const getStyles = ({globalScale, fonts, isDarkMode, colors}) => {
  return {
    dialogContentInnerSettingsOpen: () => {
      if (Platform.OS === 'web') {
        return {};
      } else {
        return {
          marginLeft: -12, // @TODO: a little hacky
          marginRight: -24, // @TODO: a little hacky
        };
      }
    },
    foo: {
      // @TODO: backgroundColor: 'lightblue',
    },
    bar: {
      // @TODO: gap: 0,
    },
    searchbar: {
      // @TODO: backgroundColor: 'lightgreen',
    },
    titleWrapper: {
      width: '100%',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      // @TODO: backgroundColor: 'salmon',
    },
    titleText: { // @TODO: combine with Dialog.Title styles
      color: colors.dialogText,
      fontSize: globalScale * 22,
      fontFamily: fonts.primaryBold,
    },
    translationSelectionWrapper: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-around',
      alignItems: 'flex-start',
      minWidth: 500,
    },
    emptyText: {
      color: colors.dialogText,
    },
    sectionWrapper: { // @TODO: in the dialog...could probably be in commonStyles
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      marginBottom: globalScale * 8, // @TODO: don't need this for licensing info dialog
    },
    contentWrapper: { // @TODO: remove
      flex: 1,
      width: '100%',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
    section: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
    },
    gap: {
      height: 32,
    },
    buttonAndSizeWrapper: {
      justifyContent: 'center',
      alignItems: 'flex-end',
      marginTop: 16,
    },
    sizeText: {
      fontSize: globalScale * 12,
      color: colors.gray,
      fontFamily: fonts.primaryItalic,
      marginTop: globalScale * 4,
    },
    descriptionText: {
      fontSize: globalScale * 14,
      color: isDarkMode ? colors.white : colors.black,
    },
    optionText: {
      textAlign: 'left',
      flexShrink: 1,
      flexGrow: 1,
    },
    translationSettingsIcon: {
      marginTop: 0,
      marginBottom: 0,
      marginRight: 0, // @NOTE: this removes the double padding for cogs
      marginLeft: 0, // @NOTE: this removes the double padding for cogs
    },
  };
};

export default getStyles;
